import { factories, service, IEmbedConfiguration } from 'powerbi-client';

const powerBi = new service.Service(
  factories.hpmFactory,
  factories.wpmpFactory,
  factories.routerFactory
);

/**
 * Embed a PowerBI paginated report using the powerbi-client service.
 *
 * This is used for paginated reports which require a different embedding approach
 * than interactive reports (which use PowerBIEmbed from powerbi-client-react).
 *
 * @param reportContainer - The HTML element to embed the report into
 * @param reportConfig - PowerBI embed configuration with embedUrl, accessToken, etc.
 * @param onError - Callback for error handling
 *
 * TODO: Add proper TypeScript types for reportConfig instead of IEmbedConfiguration
 * TODO: Consider adding success callback for consistency with error handling
 */
export const embedPowerBIReport = ({
  reportContainer,
  reportConfig,
  onError,
}: {
  reportContainer: HTMLElement;
  reportConfig: IEmbedConfiguration;
  onError: (message: string) => void;
}) => {
  if (reportContainer && reportConfig.type) {
    const report = powerBi.embed(reportContainer, reportConfig);

    report.on('error', (event: any) => {
      onError('Error loading embedded report');
      console.error('Embedded Report Error:', event);
    });

    report.off('loaded');
    report.off('error');
    report.off('rendered');
  }
};
